import { render, staticRenderFns } from "./addMemo.vue?vue&type=template&id=c9fd6eda&scoped=true"
import script from "./addMemo.vue?vue&type=script&lang=js"
export * from "./addMemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fd6eda",
  null
  
)

export default component.exports